<template>
<div>
    <b-row>
        <b-button variant="primary" size="sm" class="mr-2" @click="addMeta"><i class="fa fa-tasks"></i> Adicionar Meta</b-button>
        <b-button variant="primary" size="sm" class="mr-2" href="/adm/bonificacao"><i class="fas fa-arrow-alt-circle-right"></i> Pedidos Bonificados</b-button>
        <b-button variant="primary" size="sm" class="mr-2" href="/adm/metas/graph"><i class="fas fa-chart-bar"></i> Ver Indicadores </b-button>
    </b-row>

    <h3 class="mt-3">Metas</h3>
    <b-card>
        <b-col lg="4">
            <b-form-group label-for="filter-input" label-size="sm" class="mb-0">
                <b-input-group>
                    <b-form-input size="sm" id="filter-input" v-model="filter" type="search" placeholder="Buscar Distribuidor"></b-form-input>
                    <b-input-group-append>
                        <b-button size="sm" :disabled="!filter" @click="filter = ''">Limpar</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-table class="mt-1" :fields="colunas" hover :items="dataComputed" :current-page="currentPage" :per-page="perPage" :sort-direction="sortDirection" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" stacked="md" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" show-empty small>
            <template #cell(id)="row">
                <b-button variant="primary" @click="show(row.value)"><i class="fa fa-edit"></i></b-button>
            </template>
        </b-table>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
    </b-card>

    <!---------------- MODAL PARA INCLUIR OU EDITAR UMA META ------------------------>
    <b-modal v-model="openedModal" title="Meta" size="lg">
        <b-card>
            <b-card-body>
                <b-row>
                    <b-col class="md-12">
                        <label>Selecione o Distribuidor:</label>
                        <v-select v-model="distribuidor" :options="listaDistribuidor" :disabled="!showDistribuidor" :onSearch="loadDistribuidor"></v-select>
                    </b-col>
                </b-row>
                <b-row class="mt-3 mb-3">                    
                    <b-col class="md-6">
                            <b-form-radio v-model="tipoMeta" name="some-radios" value="1">Meta por Campanha</b-form-radio>
                    </b-col>
                    <b-col class="md-6">
                            <b-form-radio v-model="tipoMeta" name="some-radios" value="2">Meta por Mês</b-form-radio>
                    </b-col>                    
                </b-row>

               <b-row>
                   <b-col v-if="tipoMeta === '1'" class="md-4">
                        <label>Campanha:</label>
                        <v-select v-model="campanha" :options="listCampanhas"></v-select>                    
                    </b-col>
                    <b-col v-if="tipoMeta ==='2'">
                        <label for="mes">Mês:</label> 
                        <br>                     
                        <!-- <b-form-datepicker id="data-limite" type="month" label-reset-button="Limpar Data" reset-button label-help="" label-no-date-selected="Nenhuma Data Selecionada" v-model="data_limite" class="mb-2" locale="pt-br"></b-form-datepicker> -->
                        <!-- <input class="col-md-12" type="month" id="mes" v-model="mesMeta" /> -->
                        <input id="mes" v-model="mesMeta" v-mask="['##/####']" />
                    </b-col>
                </b-row>

                <div class="row mt-3">
                    <div class="col-md-4">
                        <label>Meta - <small>Quantidade de itens:</small></label>
                        <input class="form-control" v-model="meta" type="text" v-mask="['#', '# ###', '##', '## ###', '###', '### ###']" />
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-12">
                        <label>Observações:</label>
                        <textarea rows="3" class="form-control" v-model="descricao" placeholder="Digite algo sobre a meta."></textarea>
                    </div>
                </div>
            </b-card-body>
        </b-card>
        <template #modal-footer>
            <b-button variant="warning" size="sm" @click="DeletarMeta(meta_id)" v-if="meta_id > 0"><span class="fa fa-trash"></span> Deletar Meta</b-button>
            <b-button variant="primary" size="sm" @click="SalvaMeta">Salvar</b-button>
            <b-button variant="danger" size="sm" @click="openedModal = false">Cancelar</b-button>
        </template>
    </b-modal>
</div>
</template>

<script>
import moment from 'moment';
import vSelect from "vue-select";
export default {
    components: {
        vSelect,
    },
    data() {
        return {
            tipoMeta: '1',
            mesMeta: null,
            filCampanha: "",
            modalVisible: false,
            datePickerConfig: {
                format: "DD/MM/YYYY",
                showClose: true,
            },
            search: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [15, 30, 45, 100],
            sortBy: '',
            sortDesc: true,
            sortDirection: 'desc',
            colunas: [{
                    key: "codigo",
                    label: "Código",
                    sortable: true,
                },

                {
                    label: "Distribuidor",
                    key: "nome",
                    sortable: true,

                },
                {
                    label: "Quantidade",
                    key: "meta",
                    sortable: true,
                },
                {
                    label: "Data de Criação",
                    key: "data",                   
                },
                {
                    label: "Mês",
                    key: "mesMeta",
                    sortable: true,                   
                },
                {
                    label: "Campanha",
                    key: "campanha",
                    sortable: true,

                },
                {
                    label: "Classe",
                    key: "classe",
                },
                {
                    label: "#",
                    key: "id",
                },
            ],
            data: [],
            data_limite: null,
            actionsTable: ["show"],
            descricao: null,
            meta: 0,
            catalogo: 0,
            descricao: null,
            status: null,
            distribuidor: null,
            listaDistribuidor: [],
            listCampanhas: [],
            campanha: "",
            meta_id: 0,
            dataMeta: "",
            listaMeta: [],
            nomedistribuidor: "",
            showDistribuidor: true,
            errors: [],
            openedModal: false,
            filter: null,
            filterOn: [],
        };
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        initDates() {
            let m = moment();
            m.set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            });

            this.dataMeta = moment();
            this.dataMeta.set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            });
        },

        showLoading() {
            $(".loading").show();
        },
        addMeta() {
            var vm = this;
            this.showDistribuidor = true;
            this.meta = "";
            this.campanha = "";
            this.distribuidor = "";
            this.obs = "";
            this.meta_id = 0;
            this.data_limite = "";
            this.tipoMeta = '1';
            this.mesMeta = "";
            vm.openedModal = true;
        },

        loadData() {
            var vm = this;
            $(".loading").show();

            axios
                .get("/adm/metas/lista")
                .then(function (response) {
                    vm.formatDataToTable(response.data);
                    vm.totalRows = response.data.length;
                    $(".loading").hide();
                })
                .catch(function (error) {
                    console.log(error);
                    $(".loading").hide();
                });
        },

        loadDistribuidor(key) {
            var vm = this;
            this.listaDistribuidor = [];
            axios
                .get("/adm/distribuidores/combo", {
                    params: {
                        query: key,
                    },
                })
                .then(function (response) {
                    console.log(response.data);
                    var obj = response.data;
                    obj.forEach(function (v) {
                        vm.listaDistribuidor.push({
                            value: v.id,
                            label: v.codigo + " - " + v.nome,
                        });
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        formatDataToTable(dataLoaded) {
            var data = [];
            dataLoaded.forEach(function (el, index) {
                let obj = {};
                obj.id = el.id;
                obj.distribuidor = el.distribuidor.nome;
                obj.campanha = el.campanha ? el.campanha.codigo : null;
                obj.meta = el.meta;
                obj.descricao = el.descricao;
                obj.status = el.status;
                obj.codigo = el.distribuidor.codigo;
                obj.classe = el.distribuidor.classe;
                obj.nome = el.distribuidor.nome;
                obj.data = new Date(el.created_at).toLocaleDateString();
                obj.data_limite = el.data_limite;
                obj.mesMeta = el.anomes ? el.anomes : null;
                obj.tipoMeta = el.campanha ? '1' : '2';
                data.push(obj);
            });

            this.data = data;
        },
        getCampanhas() {
            var vm = this;
            $(".loading").show();
            vm.listCampanhas = [];
            axios
                .get("/adm/campanhas/list")
                .then(function (response) {
                    var obj = response.data;
                    obj.forEach(function (x) {
                        vm.listCampanhas.push({
                            value: x.id,
                            label: x.codigo,
                        });
                    });

                    $(".loading").hide();
                })
                .catch(function (error) {
                    console.log(error);
                    $(".loading").hide();
                });
        },
        show(id) {
            var vm = this;
            $(".loading").show();
            axios
                .get("/adm/metas/ver/" + id)
                .then(function (response) {
                    var list = response.data;
                    vm.showDistribuidor = false;
                    vm.meta_id = list.id;
                    vm.distribuidor = {
                        value: list.distribuidor_id,
                        label: list.distribuidor.nome,
                    };
                    vm.meta = list.meta;
                    vm.catalogo = list.catalogo;
                    vm.descricao = list.descricao;
                    vm.tipoMeta = list.anomes ? '2' : '1';
                    vm.mesMeta = vm.tipoMeta == '2' ? list.anomes : null;
                    vm.campanha = vm.tipoMeta == '1' && list.campanha ? {
                        value: list.campanha.id,
                        label: list.campanha.codigo,
                    } : null;

                    $(".loading").hide();
                    vm.openedModal = true;
                })
                .catch(function (error) {
                    console.log(error);
                    $(".loading").hide();
                });
        },
        valida() {
            if (this.tipoMeta === '1' && this.campanha === "") {
                this.$swal("Ops", "Informe a Campanha .", "error");
                return false;
            }
            if (this.tipoMeta === '2' && this.metaMes === "") {
                this.$swal("Ops", "Informe o mês da meta .", "error");
                return false;
            }
            if (this.distribuidor === "") {
                this.$swal("Ops", "Por favor, selecione um distribuidor", "error");
                return false;
            }
            if (typeof this.meta === "string") {
                if (parseInt(this.meta) === 0) {
                    this.$swal(
                        "Ops",
                        "Por favor, informe uma meta para o distribuidor",
                        "error"
                    );
                    return false;
                }
            } else {
                if (this.meta === 0) {
                    this.$swal(
                        "Ops",
                        "Por favor, informe uma meta para o distribuidor",
                        "error"
                    );
                    return false;
                }
            }

            return true;
        },
        SalvaMeta() {
            var vm = this;
            if (!this.valida()) {
                return;
            }
            $(".loading").show();

            var data = {                
                distribuidor: this.distribuidor.value,
                meta: this.meta.replace(" ", ""),
                descricao: this.descricao,
                tipoMeta: this.tipoMeta,
                mesMeta: this.tipoMeta == '2' ? this.mesMeta.replace('/','') : null,
                campanha: this.tipoMeta == '1' ? this.campanha.value : null,
                meta_id: this.meta_id,
            };

            axios
                .post("/adm/metas/salva", data)
                .then(function (response) {
                    $(".loading").hide();
                    vm.$swal("Ok", response.data.success, "success");
                    vm.meta_id = response.data.id ? response.data.id : 0;
                    vm.loadData();
                    vm.openedModal = false;
                })
                .catch(function (error) {
                    $(".loading").hide();
                    var e = error.response.data.errors;
                    vm.$swal("Ops", error.response ? e : `${error}`, "error");
                });
        },
        DeletarMeta(id) {
            var data = {};
            var vm = this;
            this.$swal
                .fire({
                    title: "Realmente deseja deletar esta meta?",
                    text: "Esta ação não poderá ser revertida!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim Deletar!",
                    cancelButtonText: "Cancelar",
                })
                .then((result) => {
                    if (result.value) {
                        $(".loading").show();
                        axios
                            .post("/adm/metas/destroy/" + id, data)
                            .then(function (response) {
                                $(".loading").hide();
                                vm.$swal("Ok!", response.data.success, "success");
                                vm.loadData();
                                vm.openedModal = false;
                            })
                            .catch(function (error) {
                                $(".loading").hide();
                                var e = error.response.data.errors;
                                vm.$swal("Ok", error.response ? e : `${error}`, "error");
                            });
                    }
                });
        },
    },
    computed: {
        filteredData() {
            return this.data.filter((item) => {
                return (
                    item.distribuidor.toLowerCase().indexOf(this.search.toLowerCase()) >
                    -1
                );
            });
        },
        dataComputed() {
            var data = this.data;
            const vm = this;
            if (this.filCampanha) {
                data = data.filter((it) => {
                    return it.campanha.indexOf(vm.filCampanha) > -1;
                });
            }
            return data;
        },
        ObjListaDistribuidor() {
            var arrayDistribuidor = [];
            var vm = this;
            this.listaDistribuidor.forEach(function (item, index) {
                if (vm.distribuidor == item.id) {
                    vm.nomedistribuidor = item.codigo;
                }
                arrayDistribuidor.push({
                    value: item.id,
                    label: item.codigo,
                });
            });
            return arrayDistribuidor;
        },
    },
    mounted() {
        this.loadData();
        this.getCampanhas();
        this.initDates();
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_metas/List.vue